module.exports = "<thank-you isError=\"true\">\n    <p id=\"common-error-message\">{{'COMMON.ERROR'|translate}}</p>\n</thank-you>\n"


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/modules/error/error.template.html
// module id = 892
// module chunks = 0